import { useMemo } from 'react';
import { useCollectionsStore } from '../store/collectionsStore';
import { useTabsStore, selectCurrentRequestTab } from '../store/tabsStore';
import { folderVariablesForTab } from '../utils/folderVariables';

/**
 * Folder variables for the request tab on screen (nearest folder first), from
 * the stores: the current request tab and the sidebar collections. Same folder
 * source as the folder auth chain (the sidebar record).
 *
 * Lives in EditorPane — the component that renders RequestBuilder — rather
 * than as an App memo handed down, so the real editor wiring is testable end to
 * end (review N2: the App memo could be deleted with the suite green).
 */
export function useRequestFolderVariables() {
  const currentRequestTab = useTabsStore(selectCurrentRequestTab);
  const collections = useCollectionsStore((s) => s.collections);
  return useMemo(
    () => folderVariablesForTab(currentRequestTab, collections),
    [currentRequestTab, collections]
  );
}

export default useRequestFolderVariables;
